import nlPoly from './nlPoly';
import bePoly from './bePoly';
import { waypointInPolygon } from './polygon';

function checkCountry(pts) {
  if (pts.every(waypointInPolygon(nlPoly))) {
    return 'nl';
  }
  if (pts.every(waypointInPolygon(bePoly))) {
    return 'be';
  }
  return '';
}

export default checkCountry;
